import $ from 'jquery'
import { lockScreen, unlockScreen } from './screenLocker'

const $nav = $('#nav-global')
const $btnClose = $nav.find('.js-btn-close')
const $overlay = $('<div>', { class: 'c-overlay-nav-global js-overlay-nav-global' })
const OPEN_CLASS = '-is-open'

const navOpen = () => {
  $nav.addClass(OPEN_CLASS)
  $overlay.stop().fadeIn(200)
  lockScreen()
}

const navClose = () => {
  $nav.removeClass(OPEN_CLASS)
  $overlay.stop().fadeOut(200)
  unlockScreen()
}

const initOverlay = () => {
  $overlay.appendTo('body')
  $overlay.on('click', navClose)
}

const openButton = () => {
  const $menu = $('#header').find('.js-header-menu')

  $menu.on('click', () => {
    if ($nav.hasClass(OPEN_CLASS)) {
      navClose()
    } else {
      navOpen()
    }
  })
}

const closeButton = () => {
  $btnClose.on('click', navClose)
}

const initNavGlobal = () => {
  initOverlay()
  openButton()
  closeButton()
}

export default initNavGlobal
